import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsTeradataComponent } from './simple-icons-teradata.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsTeradataComponent ],
    exports:      [ SimpleIconsTeradataComponent ],
    bootstrap:    []
})
export class SimpleIconsTeradataModule {}
